import React, {useEffect, useState} from 'react';
import {Link, useParams} from "react-router-dom";
import {Button, ButtonToolbar, OverlayTrigger, Tooltip} from "react-bootstrap";
import { toast } from "react-toastify";
import MaintainerAPI from "../../../apis/maintainerApi/MaintainerAPI";
import TableLoader from "../../loaders/TableLoader";
import Pagination from "../../assets/Pagination";
import Moment from "moment";
import PrintComponent from "./printer";

const AllBusMechanicTask = () => {

    const [mechanicsTasks, setMechanicTasks] = useState([]);
    const [bus, setBus] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);
    const [setting, setSetting] = useState([]);

    //Permet d'aller recuperer les invoices
    const fetchMechanicTasks = async () => {
        try{
            const data =  await MaintainerAPI.findMechanicTasks();
            setMechanicTasks(data);
            setBus([]);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des mouvements !");
        }
    };

    const fetchSetting = async () => {
        try{
            const data =  await MaintainerAPI.findSetting();
            setSetting(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des paramettres !");
        }
    };



    //Au chargement du composant on va chercher les mechanicsTasks
    useEffect(() => {
        fetchSetting();
        fetchMechanicTasks();
    }, []);


    const tooltip = (data) => (
        <Tooltip className="in" id="tooltip">
            <p>{data}</p>
        </Tooltip>
    );

    //Gestion du changement de page
    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 100;
    const filteredMechanicTasks = mechanicsTasks.filter(
        b =>
            b.city.toLowerCase().includes(search.toLowerCase()) ||
            b.driver_name.toLowerCase().includes(search.toLowerCase()) ||
            b.bus_numberplate.toLowerCase().includes(search.toLowerCase()) ||
            b.bus_brand.toLowerCase().includes(search.toLowerCase()) ||
            b.complaint.toLowerCase().includes(search.toLowerCase()) ||
            b.observation.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedMechanicTasks = Pagination.getData(
        filteredMechanicTasks,
        currentPage,
        itemsPerPage
    );

    let counter = 1;


    return (
        <>
            <div className="pagetitle">
                <h1>Les entretiens</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/maintainer">Dashboard</Link></li>
                        <li className="breadcrumb-item active">Entrerien de bus</li>
                    </ol>
                </nav>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6">
                                        <h5 className="card-title">Total {mechanicsTasks ? mechanicsTasks.length : 0}</h5>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group mt-3">
                                            <input type="text" onChange={handleSearch} value={search} className="form-control" placeholder="Rechercher ..." />
                                        </div>
                                    </div>
                                </div>

                                <table className="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">MECANICIEN</th>
                                        <th scope="col">Bus</th>
                                        <th scope="col">Chauffeur</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">PLAINTE</th>
                                        <th scope="col">PIECE DE RECHANGE</th>
                                        <th scope="col">OBSERVATION</th>
                                        <th scope="col">Options</th>
                                    </tr>
                                    </thead>
                                    {!loading && <tbody>
                                    {paginatedMechanicTasks.map((mechanicTask) => (
                                            <tr key={mechanicTask.id}>
                                                <th scope="row">{counter++}</th>
                                                <td>
                                                    <ul>
                                                        {mechanicTask.mechanics_in_task.map((item) =>
                                                            <li>{item.mechanic_name}</li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td>{mechanicTask.bus_brand}<br/>{mechanicTask.bus_numberplate} </td>
                                                <td>{mechanicTask.driver_name}</td>
                                                <td>Le {Moment(mechanicTask.input_date).format("DD/MM/YYYY")}</td>
                                                <td>{mechanicTask.complaint}</td>
                                                <td>
                                                    <ul>
                                                        {mechanicTask.products_in_tasks.map((item) =>
                                                            <li>{item.product_name} : {item.task_id} {item.task_name}</li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td>{mechanicTask.observation}</td>
                                                <td></td>
                                                <td>
                                                    <div className="btn-group">
                                                        <Link title="ajouter une piece" className="btn btn-sm btn-dark" to={`/maintainer/mechanicTasks/${mechanicTask.id}/addProduct`}>
                                                            <i className="bi bi-boxes"></i> <i className="bi bi-plus-lg"></i>
                                                        </Link>
                                                        <Link title="ajouter un mecanicier" className="btn btn-sm btn-success" to={`/maintainer/mechanicTasks/${mechanicTask.id}/addMechanic`}>
                                                            <i className="bi bi-person-gear"></i> <i className="bi bi-plus-lg"></i>
                                                        </Link>
                                                        <Link title="Modifier" className="btn btn-sm btn-danger" to={`/maintainer/mechanicTasks/${mechanicTask.id}/edit`}>
                                                            <i className="bi bi-pencil-fill"></i>
                                                        </Link>
                                                        <button className="btn btn-primary">
                                                            <PrintComponent bus={bus} setting={setting} mechanicsTasks={mechanicsTasks} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>}
                                </table>
                                {loading && <TableLoader width={300} height={350} />}

                                {itemsPerPage < filteredMechanicTasks.length &&
                                <Pagination
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    length={filteredMechanicTasks.length}
                                    onPageChange={handleChangeCurrentPage}
                                />
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AllBusMechanicTask;
